export const AGSREPORT_URL = 'report/ddc';